module.exports = __webpack_public_path__ + "img/PhilGray.3802e425.jpg";